"use client";

import React from "react";
import { Building2, Target, Lightbulb, ArrowRight, CircleCheck } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const solutions = [{
  id: "scale",
  title: "Zonnepanelen Projecten",
  description: "Grootschalige installaties voor woningbouw en utiliteit. Wij regelen de materialen, jij de expertise.",
  icon: Building2,
  capabilities: ["15+ klussen direct beschikbaar", "Materialen op locatie geleverd", "Wekelijkse betaling gegarandeerd"],
  className: "md:col-span-2 bg-primary text-primary-foreground border-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642666/img/industrial_scale_project.png')] bg-cover bg-center",
  overlay: "bg-primary/90 group-hover:bg-primary/95 transition-colors duration-500",
  iconColor: "text-accent-foreground",
  linkColor: "text-accent-foreground hover:text-accent-foreground/80"
}, {
  id: "tailor",
  title: "Thuisbatterijen",
  description: "Snelgroeiende markt voor slimme energieopslag en onafhankelijkheid.",
  icon: Target,
  capabilities: ["8+ actieve aanvragen", "Gecertificeerde systemen", "Regio-specifieke klussen"],
  className: "md:col-span-1 bg-card text-card-foreground border-border",
  overlay: "bg-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500",
  iconColor: "text-primary",
  linkColor: "text-primary hover:text-primary/80"
}, {
  id: "dreams",
  title: "Duurzame Warmtepompen",
  description: "Word onze partner voor de installatie van hybride en volledige warmtepompsystemen. Wij zorgen voor een stabiele planning en voorbereiding.",
  icon: Lightbulb,
  capabilities: ["12+ klussen in de planning", "Focus op Lucht-Water systemen", "Professionele werkvoorbereiding"],
  className: "md:col-span-3 bg-secondary text-secondary-foreground border-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642666/img/warm_dreams_collaboration.png')] bg-cover bg-center",
  overlay: "bg-secondary/90 group-hover:bg-secondary/95 transition-colors duration-500",
  iconColor: "text-primary",
  linkColor: "text-primary hover:text-primary/80"
}];
export default function OurSolutionLines() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="225571" id="onze-expertisegebieden" className="py-24 bg-background relative overflow-hidden dark text-foreground">
      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-3xl mb-16 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-3xl md:text-5xl font-default font-bold text-foreground mb-6 tracking-tight">
            Onze Expertisegebieden
          </h2>
          <p className="text-lg text-muted-foreground font-sans">Bij CL installaties bieden we ZZP-installateurs directe toegang tot hoogwaardige projecten. Ontdek onze focusgebieden en vind de klus die bij jouw vakmanschap past.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 auto-rows-[450px]">
          {solutions.map((solution, i) => {
          const Icon = solution.icon;
          return <Card key={solution.id} data-index={i} className={`group relative overflow-hidden rounded-2xl ${solution.className} transition-all duration-700 hover:shadow-2xl hover:-translate-y-1`}>
                {}
                <div className={`absolute inset-0 z-0 ${solution.overlay}`} />

                <div className="relative z-10 flex flex-col h-full p-8 md:p-10">
                  {}
                  <div className="mt-auto transition-transform duration-500 ease-out group-hover:-translate-y-32 md:group-hover:-translate-y-28">
                    <div className={`w-14 h-14 rounded-lg bg-background/10 backdrop-blur-sm flex items-center justify-center mb-6 ${solution.iconColor}`}>
                      <Icon className="w-7 h-7" />
                    </div>
                    <h3 className="text-2xl md:text-3xl font-default font-bold mb-3">
                      {solution.title}
                    </h3>
                    <p className="font-sans text-base opacity-90 max-w-lg">
                      {solution.description}
                    </p>
                  </div>

                  {}
                  <div className="absolute bottom-8 left-8 right-8 md:bottom-10 md:left-10 md:right-10 opacity-0 translate-y-8 transition-all duration-500 ease-out group-hover:opacity-100 group-hover:translate-y-0 pointer-events-none group-hover:pointer-events-auto">
                    <div className="w-full h-px bg-current opacity-20 mb-6" />
                    <ul className="space-y-3 mb-8">
                      {solution.capabilities.map((capability, j) => <li key={j} data-index={j} className="flex items-center gap-3 font-sans text-sm md:text-base font-medium">
                          <CircleCheck className="w-5 h-5 opacity-70 shrink-0" />
                          <span>{capability}</span>
                        </li>)}
                    </ul>
                    <Link to="#" className={`inline-flex items-center gap-2 font-default font-semibold text-sm uppercase tracking-wider transition-colors ${solution.linkColor}`}>
                      Bekijk klussen
                      <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                    </Link>
                  </div>
                </div>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}